import React from 'react';
import { ItemList } from 'components/item-list/ItemList';
import { ItemListItem } from 'components/item-list/ItemListItem';
import { RichText } from 'components/rich-text/RichText';

export const ItemListSlice = ({ title, text, numbered, items, isSlice, isSplitPage }) => {
  return (
    <ItemList
      title={title}
      text={RichText.render(text)}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
    >
      {items?.map((item, index) => (
        <ItemListItem
          key={index}
          index={index + 1}
          title={item.title}
          text={RichText.render(item.text)}
          numbered={numbered}
        />
      ))}
    </ItemList>
  );
};

export default ItemListSlice;
